import { Modal, ModalProps } from 'react-bootstrap';
import sucessImage from '../../assets/sucess.png';
import errorImage from '../../assets/error.png';

import { useInduction } from '../../hooks/useInduction';
import { ModalContainer, ModalTitle, Conten, Container } from './styles';

interface AlertModalProps extends ModalProps {
    isOpen: boolean;
    onRequestClose: () => void;
    sucess: boolean;
    termAccepted: boolean;
    isUpdate: boolean;
}

export default function AlertModal({ isOpen, onRequestClose, sucess, termAccepted, isUpdate }: AlertModalProps) {

    const { benefitName } = useInduction();

    return (
        <ModalContainer>
            <Modal
                show={isOpen}
                onHide={onRequestClose}
                animation={false}
                backdrop="static"
                keyboard={false}
                size="lg"
            >
                <Conten>
                    <Modal.Header closeButton>
                        <div className="header-container">
                            <ModalTitle>Atenção</ModalTitle>
                        </div>
                    </Modal.Header>
                    <Modal.Body>
                        <Container>
                            {sucess ? (
                                <>
                                    <img src={sucessImage} alt="" />
                                    <span className={termAccepted ? 'term-accepted' : ''}>Cadastro {isUpdate ? 'atualizado' : 'realizado'} com sucesso!</span>
                                    {!termAccepted && <p>Cadastro {isUpdate ? 'atualizado' : 'realizado'} com sucesso! É necessário obter o consentimento do paciente o quanto antes para que o mesmo acesse todos os benefícios do programa {benefitName} por tempo indeterminado.</p>}
                                </>
                            ) : (
                                <>
                                    <img src={errorImage} alt="" />
                                    <span>Por favor, tente novamente mais tarde.</span>
                                    <p>Ocorreu um erro ao salvar os dados do beneficiário e o cadastro não foi concluído.</p>
                                </>
                            )}

                        </Container>
                    </Modal.Body>
                </Conten>
            </Modal>
        </ModalContainer>
    );
}